import MegaSale, { MegaSalePageProps } from '@v2/shared/Pages/MegaSale';

export type { MegaSalePageProps };

/**
 * The sale page, on DiscountMags.
 *
 * The page itself is `shared/Pages/MegaSale` and every brand draws the same one. This
 * file exists for a single fact: DiscountMags is the brand that shows "Did you know you
 * can gift magazines to your friends?" after the first section, and no other brand does.
 *
 * A wrapper in the brand folder rather than a `=== 'discountmags'` anywhere, because that
 * comparison is the thing `shared/` is not allowed to contain and a template is no better
 * a place for it — the folder whose name *is* the brand is where a brand's answer belongs.
 * It is the same shape as `digitalLibrary` in `shared/Layouts/Account/menu.ts`: a fact
 * settled by which brand you are on, answered by that brand, and promoted to a site option
 * only if one storefront ever has to disagree with its brand.
 *
 * `layoutName` has to be restated here. `tree.tsx` reads it off whatever `resolveComponent`
 * returned, which on this brand is this function and not the page it wraps — without it
 * the DiscountMags sale would render with no chrome at all.
 */
export default function DiscountMagsMegaSale(props: MegaSalePageProps) {
  return <MegaSale {...props} showGiftingPromo />;
}

DiscountMagsMegaSale.layoutName = 'Layouts.MegaSale';
